import { fetchApi } from '../apiClient';

/**
 * 删除用户账号
 * 
 * 此函数会：
 * 1. 调用后端 API 删除用户账号
 * 2. 后端会使用 Supabase Admin API 删除用户
 * 3. 数据库级联删除会自动清理所有关联数据
 * 
 * @throws {Error} 如果删除失败则抛出错误
 */
export const deleteUserAccount = async (): Promise<void> => {
  const response = await fetchApi('/user/delete', {
    method: 'DELETE',
  });
  
  if (!response.success) {
    throw new Error(response.error || '删除账号失败');
  }
};
